import React from 'react';
import { cn } from '../../utils/cn';

export function Divider({ orientation = 'horizontal', label, className, ...rest }) {
  if (orientation === 'vertical') {
    return <div role="separator" aria-orientation="vertical" className={cn('w-px h-full bg-border', className)} {...rest} />;
  }

  if (label) {
    return (
      <div role="separator" className={cn('flex items-center gap-3 my-3', className)} {...rest}>
        <span className="flex-1 h-px bg-border" />
        <span className="text-xs uppercase tracking-wider text-mute font-mono">{label}</span>
        <span className="flex-1 h-px bg-border" />
      </div>
    );
  }

  return <hr role="separator" className={cn('border-0 h-px bg-border my-3', className)} {...rest} />;
}

export default Divider;
